import { Spinner } from 'react-bootstrap';

import MonitoringAlertsSection from './components/MonitoringAlertsSection';
import MonitoringApiLogTable from './components/MonitoringApiLogTable';
import MonitoringKpiGrid from './components/MonitoringKpiGrid';
import MonitoringProductionSection from './components/MonitoringProductionSection';
import { EMPTY_MESSAGES } from './constants';
import { useRealtimeMonitoring } from './useRealtimeMonitoring';
import './RealtimeMonitoringTab.css';

function getSummaryErrorMessage(error: unknown): string {
  const err = error as { data?: { error?: string }; error?: string };
  return err?.data?.error ?? err?.error ?? EMPTY_MESSAGES.summaryErrorFallback;
}

const RealtimeMonitoringTab = () => {
  const { summary, kpis, charts, apiLog } = useRealtimeMonitoring();

  return (
    <div className="realtime-monitoring-tab">
      <header className="realtime-monitoring-tab__page-header">
        <h1 className="realtime-monitoring-tab__page-title">MicroEAI Realtime Monitoring</h1>
        <p className="realtime-monitoring-tab__page-subtitle">Live API activity, risk signals, and alert events</p>
      </header>

      {summary.isLoading ? (
        <div className="text-center py-5">
          <Spinner animation="border" size="sm" role="status" />
          <p className="text-muted small mt-2 mb-0">{EMPTY_MESSAGES.loadingSummary}</p>
        </div>
      ) : summary.isError ? (
        <div className="p-4 border border-danger rounded-3 bg-danger-subtle text-danger small">
          {getSummaryErrorMessage(summary.error)}
        </div>
      ) : summary.data ? (
        <div className="realtime-monitoring-tab__content">
          <MonitoringKpiGrid cards={kpis} />
          <MonitoringProductionSection
            apiCallsOption={charts.options.apiCalls}
            riskScoresOption={charts.options.riskScores}
            costOption={charts.options.cost}
            hourlyLoading={charts.loading.hourly}
            riskLoading={charts.loading.risk}
            costLoading={charts.loading.cost}
            costChartHeight={charts.costChartHeight}
          />
          <MonitoringAlertsSection
            severityOption={charts.options.severity}
            controlOption={charts.options.control}
            severityLoading={charts.loading.severity}
            controlLoading={charts.loading.control}
            chartHeight={charts.alertsChartHeight}
          />
          <MonitoringApiLogTable
            rows={apiLog.rows}
            page={apiLog.page}
            totalPages={apiLog.totalPages}
            total={apiLog.total}
            rangeStart={apiLog.rangeStart}
            rangeEnd={apiLog.rangeEnd}
            busy={apiLog.busy}
            isInitialLoading={apiLog.isInitialLoading}
            onPageChange={apiLog.setPage}
            visiblePages={apiLog.pagination.visiblePaginationItems}
            hasPrevEllipsis={apiLog.pagination.hasPrevEllipsis}
            hasNextEllipsis={apiLog.pagination.hasNextEllipsis}
          />
        </div>
      ) : (
        <div className="realtime-monitoring-tab__chart-panel">
          <div
            className="d-flex align-items-center justify-content-center w-100 realtime-monitoring-tab__empty-state"
            style={{ height: 200, padding: '0 20px', textAlign: 'center' }}
            role="status"
          >
            {EMPTY_MESSAGES.summaryUnavailable}
          </div>
        </div>
      )}
    </div>
  );
};

export default RealtimeMonitoringTab;
